import { ApiUserProduct, ProductsApiFactory, SignOutApiFactory } from "./typescript_api_client";
import config from "./config";

export const { getUserProducts } = ProductsApiFactory(config, config.basePath);
export const { signOut } = SignOutApiFactory(config, config.basePath);
export type Product = ApiUserProduct;
